import styled from "styled-components";
// import topBanner from '../public/images/assets/artist-bg.jpg';
import headerbanner from '../public/images/assets/resource-banner.jpg';
import resourcebanner from '../public/images/assets/resourceBanner.jpg';
import artistBanner from '../public/images/assets/artistBanner.jpg';

export const Container = styled.div`
.home-banner,.selectable-home-banner{
    background-size: cover;
    background-position: center 80%;
    background-repeat:no-repeat;
    position: relative;
    min-height: 700px;
    position:relative;
    z-index:1;
::after{
    content:'';
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(0,0,0,0.3);
    z-index:-1;
}
@media (max-width:600px){
    background-position:0%;
}
}
.selectable-home-banner{
    min-height: 250px;
    background-image:url(${artistBanner.src});
    background-position: center;

}
.nav-container{
    
.logo-wrapper{
   height:150px;
   width:150px;
   overflow:hidden;
   float:left;
}

.nav{
    .nav-links{
        margin:0;
        padding:0;
        .nav-item{
            display: block;
            padding: 5px 10px;
            font-size: 16px;
            cursor:pointer;
        }
    }
}
}

.search-container{
    padding-top: 12%;
    left:50%;
    transform:translate(-50%);
    .search-title{
        display:inline;
        width:200px;
        text-align:center;
        font-size:20px;
        text-transform:uppercase;
    }
    input{
        border:none;
        outline:none;
    }
    z-index: 2;

    .appended-icon{
        top: 50%;
        transform: translate(100%,-50%); 
    }
    .search-icon{
        top: 50%;
        right: 0;
        transform: translate(0,-50%); 
    }       

}
.categories-container{
    position:absolute;
    bottom:0;
    left:50%;
    transform:translate(-50%,0);
    background-color: rgba(0,0,0,0.6);
    width:100%;
    padding:30px 0;
 .categories-list{
    display:grid;
    grid-template-columns:repeat(3,120px);
    align-items:flex-end;
    justify-content:center;
    gap:20px;
    .categories-item{
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        cursor:pointer;
 .circle-wrapper{
    width: 56px;
    height: 56px;
    overflow: hidden;
    display: flex;
    align-items:center;
    justify-content:center;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid #1478dd;
    position: relative;
    border-radius: 5000px;

 :hover{
    background-color: #1478dd;
    -moz-transition: background-color .3s ease;
    -o-transition: background-color .3s ease;
    -webkit-transition: background-color .3s ease;
    transition: background-color .3s ease;
 }

 }

 }
 }
}

.artist-container,.selectable-artist-container{
    .mt-15{
        margin-top: 15px !important;
    }
    .artist-categories-list:first-of-type{
        border: 1px solid #dee2e6;
        padding:0 !important;
        margin:0;
        li{
            padding:15px;
            background:#f1f1f1;
            border-bottom: 1px solid #d2d2d2;
            a{
                font-size:17px !important;
            }
        }
        li:last-child{
            border-bottom:none;
        }
       .artist-categories-list{
        border:none;
        li{
            padding:5px 0;
            padding-left:10px;
            border:none;
            .down-icon,.right-icon{
                display:none;
            }
            a{
                font-size:16px !important;
            }
        }
       }
    }
    .grid-container{
        display:grid;
        grid-template-columns:repeat(1,320px);
        gap:15px;
        justify-content:center;
        .artist-card{
            border:1px solid #d2d2d2;
            box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
            
        :hover{
           box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
        }
        .artist-title{
            height:22px;
            overflow:hidden;
        }
        .artist-categories{
            height:43.3px;
            overflow:hidden;
        }
        .artist-description{
            max-height:64.9px;
            overflow:hidden;
        }
        .artist-address{
            max-height:40px;
            overflow:hidden;
        }
        .artist-info{
            height:230px;
            overflow:hidden;
        }
            .profile-container{
                .profile-image{
                    height:100px;
                    width:100px;
                    border-radius:50%;
                    overflow:hidden;
                    background-repeat:no-repeat;
                    background-position:center;
                    background-size:cover;
                    border:1px solid #d2d2d2;
                }
                .description{
                }
                .bg-grey{
                    background:#f2f8fd;
                }
            }
        }
    }
}

.accordion__button{
    display:flex; 
    align-items:center;
}

.accordion-items{
    .accordion__button{
        background-color:#f1f1f1;
    }
    .accordion__button::before{
    display:none;
}}
.active-filter{
    background-color: #ddd;
}
.filter-items:hover{
    background-color: #ddd;
}
.filter-title{
    font-size:22px;
}
@media (min-width: 768px){
    
    .search-container{
        .search-title{
            font-size:30px;
        }
        .appended-icon{
            top: 50%;
            transform: translate(100%,-50%); 
        }
        .search-icon{
            top: 50%;
            right: 0;
            transform: translate(0,-50%); 
        }       
    }
    .categories-container{
    .categories-list{
        display:grid;
        grid-template-columns:repeat(4,120px);
    }
    }

    .artist-container,.selectable-artist-container{
        .grid-container{
            display:grid;
            grid-template-columns:repeat(2,320px);
            .artist-card{
                border:1px solid #d2d2d2;
                box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
            
            :hover{
               box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
            }
                .profile-container{
                    .profile-image{
                        height:100px;
                        width:100px;
                        border-radius:50%;
                        overflow:hidden;
                        background-repeat:no-repeat;
                        background-position:center;
                        background-size:cover;
                        border:1px solid #d2d2d2;
                    }
                    .description{
                    }
                    .bg-grey{
                        background:#f2f8fd;
                    }
                }
            }
        }
    }
    

}
@media (min-width: 920px){
    .home-banner,.selectable-home-banner{
        min-height:500px;
    }
    .text-lg-white{
        color:#fff;
    }
    .bg-lg-transparent{
        background:transparent !important;
    }
    .home-banner{
        min-height: 740px;
    }

    .nav{
        float:right;
        .nav-links{
            margin:0;
            padding:0;
            .nav-item{
                display:inline-block !important;
                padding: 5px 10px !important;
                font-size: 16px;
                cursor:pointer;
            :hover{
                text-decoration:underline;
                background:transparent;
            }
            }
        }
    }
    .w-lg-auto{
        width:auto !important;
    }
    .categories-container{
    .categories-list{
            display:grid;
            grid-template-columns:repeat(7,120px);
    .categories-item{
    .circle-wrapper{
        width: 75px;
        height: 75px;
    }
    }
    }
    }
    
    .artist-container,.selectable-artist-container{
        .grid-container{
            display:grid;
            grid-template-columns:repeat(2,320px);
            .artist-card{
                border:1px solid #d2d2d2;
                box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
            
            :hover{
               box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
            }
                .profile-container{
                    .profile-image{
                        height:100px;
                        width:100px;
                        border-radius:50%;
                        overflow:hidden;
                        background-repeat:no-repeat;
                        background-position:center;
                        background-size:cover;
                        border:1px solid #d2d2d2;
                    }
                    .description{
                    }
                    .bg-grey{
                        background:#f2f8fd;
                    }
                }
            }
        }
    }

}


@media(min-width:1280px){
    .artist-container,.selectable-artist-container{
        .grid-container{
            display:grid;
            grid-template-columns:repeat(2,320px);
            .artist-card{
                border:1px solid #d2d2d2;
                box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
            
            :hover{
               box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
            }
                .profile-container{
                    .profile-image{
                        height:100px;
                        width:100px;
                        border-radius:50%;
                        overflow:hidden;
                        background-repeat:no-repeat;
                        background-position:center;
                        background-size:cover;
                        border:1px solid #d2d2d2;
                    }
                    .description{
                    }
                    .bg-grey{
                        background:#f2f8fd;
                    }
                }
            }
        }
    }
}

@media(min-width:1300px){
    .artist-container,.selectable-artist-container{
        .grid-container{
            display:grid;
            grid-template-columns:repeat(3,320px);
            .artist-card{
                border:1px solid #d2d2d2;
                box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
            
            :hover{
               box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
            }
                .profile-container{
                    .profile-image{
                        height:100px;
                        width:100px;
                        border-radius:50%;
                        overflow:hidden;
                        background-repeat:no-repeat;
                        background-position:center;
                        background-size:cover;
                        border:1px solid #d2d2d2;
                    }
                    .description{
                    }
                    .bg-grey{
                        background:#f2f8fd;
                    }
                }
            }
        }
    }
    .selectable-artist-container{{
        .grid-container{
            display:grid;
            grid-template-columns:repeat(4,320px);
        }
    }
}

`;
export const ArtistResourcesContainer = styled.div`


.home-banner{
    background-image:url(${headerbanner.src});
    background-size: cover;
    background-position: center;
    background-repeat:no-repeat;
    position: relative;
    min-height: 800px;
    position:relative;
    z-index:1;
::after{
    content:'';
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(0,0,0,0.3);
    z-index:-1;
}



.categories-container{
    position:absolute;
    bottom:0;
    left:50%;
    transform:translate(-50%,0);
    background-color: rgba(0,0,0,0.6);
    width:100%;
    padding:30px 0;
 .categories-list{
    display:grid;
    grid-template-columns:repeat(3,120px);
    align-items:flex-end;
    justify-content:center;
    gap:20px;
    .categories-item{
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        cursor:pointer;
 .circle-wrapper{
    width: 56px;
    height: 56px;
    overflow: hidden;
    display: flex;
    align-items:center;
    justify-content:center;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid #1478dd;
    position: relative;
    border-radius: 5000px;

 :hover{
    background-color: #1478dd;
    -moz-transition: background-color .3s ease;
    -o-transition: background-color .3s ease;
    -webkit-transition: background-color .3s ease;
    transition: background-color .3s ease;
 }

 }

 }
 }
}

}
.categories-title{
    min-height:60px;
}
@media (min-width: 768px){
    min-height: 600px;
    .home-banner{
    .categories-container{
        .categories-list{
                display:grid;
                grid-template-columns:repeat(4,120px);
        .categories-item{
        .circle-wrapper{
            width: 75px;
            height: 75px;
        }
        }
        }
        }
    }
}

@media (min-width: 920px){
    min-height: 600px;
    .home-banner{
    .categories-container{
        .categories-list{
                display:grid;
                grid-template-columns:repeat(7,120px);
        .categories-item{
        .circle-wrapper{
            width: 75px;
            height: 75px;
        }
        }
        }
        }
    }
}

.search-container{
    padding-top: 12%;
    left:50%;
    transform:translate(-50%);
    .search-title{
        display:inline;
        width:200px;
        text-align:center;
        font-size:20px;
        text-transform:uppercase;
    }
    input{
        border:none;
        outline:none;
    }
    z-index: 2;

    .appended-icon{
        top: 50%;
        transform: translate(100%,-50%); 
    }
    .search-icon{
        top: 50%;
        right: 0;
        transform: translate(0,-50%); 
    }       
    @media (min-width: 768px){
            .search-title{
                font-size:30px;
            }
            .appended-icon{
                top: 50%;
                transform: translate(100%,-50%); 
            }
            .search-icon{
                top: 50%;
                right: 0;
                transform: translate(0,-50%); 
            } 
    }
}

.resource-grid{
    display:grid;
    grid-template-columns:repeat(1,300px);
    grid-template-rows:repeat(6,minmax(1fr,auto));
    gap:20px;
    padding:2rem 2.5rem; 
    @media (min-width: 768px){
        display:grid;
        grid-template-columns:repeat(2,300px);
        grid-template-rows:repeat(3,minmax(280px,auto));
    }
    @media (min-width: 920px){
        display:grid;
        grid-template-columns:repeat(3,300px);
        grid-template-rows:repeat(2,minmax(280px,auto));
    }
    .resource-item{
      
      cursor:pointer;
      background-repeat:no-repeat;
      background-size:cover;
      color:#fff;
      font-size:30px;
      overflow:hidden;
      box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
      :hover{
        box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
     }
   
    }
  
}


.resource-container{
 
    .resource-banner{
        height:350px;
        width:100%;
        background-image:url(${resourcebanner.src});
        background-size: 100%;
        background-position: center;
        background-repeat:no-repeat;
        position:relative;
        .glassmorphic{
            width:100%;
            height:100%;
            background:rgba(0,0,0,0.4);
        }
        .resource-logo-wrapper{
            height:150px;
            width:150px;
            overflow:hidden;
            float:left;
         }
        .banner-title{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            font-size:3.5rem;
        }
        
    }
       
    .description{
        overflow-wrap:anywhere;
    }
    @media (max-width:600px){
        .resource-banner{
            height:250px;
            .banner-title{{
                font-size:2.8rem;
              }
        }
      
    }
    
    }

`;

export const ResourceContainer = styled.div`
.resource-category-container{

    .resource-banner{
        background-repeat: no-repeat;
        background-position: 100% 100%;
        background-size: 40%;
        position:relative;
       
        .banner-title{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            font-size:3.5rem;
        }
        
    }
       
    .description{
        overflow-wrap:anywhere;
    }
    @media (max-width:920px){
        .resource-banner{
        background-repeat: no-repeat;
        background-position: 100% 100%;
        background-size: 50%;
        position:relative;
        }
      
    }
    
}
`;